import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { ChangePasswordModal } from "@/components/ChangePasswordModal";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, LogOut, PhoneCall, KeyRound, LifeBuoy } from "lucide-react";

export function Header({ onSchedule }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAuthed = user && user !== null;
  const [pwOpen, setPwOpen] = useState(false);

  return (
    <header className="glass sticky top-0 z-50 w-full">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Logo />
        <div className="flex items-center gap-2 sm:gap-3">
          <Button
            data-testid="header-support-btn"
            variant="ghost"
            onClick={() => navigate("/support")}
            className="rounded-full text-zinc-300 hover:text-white hover:bg-white/5"
          >
            <LifeBuoy className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Support</span>
          </Button>
          <Button
            data-testid="header-schedule-btn"
            onClick={onSchedule}
            className="rounded-full bg-primary px-4 sm:px-6 font-medium text-white hover:bg-primary/90 hover:shadow-[0_0_24px_rgba(59,130,246,0.55)] transition-[background-color,box-shadow]"
          >
            <PhoneCall className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Request a Call Back</span>
            <span className="sm:hidden">Call Back</span>
          </Button>
          {isAuthed ? (
            <>
              <Button
                data-testid="header-dashboard-btn"
                variant="ghost"
                onClick={() => navigate(user.role === "admin" ? "/admin" : user.role === "employee" ? "/employee" : "/dashboard")}
                className="rounded-full text-zinc-300 hover:text-white hover:bg-white/5"
              >
                <LayoutDashboard className="h-4 w-4 sm:mr-2" />
                <span className="hidden sm:inline">Dashboard</span>
              </Button>
              <Button
                data-testid="header-change-password-btn"
                variant="ghost"
                onClick={() => setPwOpen(true)}
                title="Change password"
                className="rounded-full text-zinc-400 hover:text-white hover:bg-white/5"
              >
                <KeyRound className="h-4 w-4" />
              </Button>
              <Button
                data-testid="header-logout-btn"
                variant="ghost"
                onClick={() => { logout(); navigate("/"); }}
                className="rounded-full text-zinc-400 hover:text-white hover:bg-white/5"
              >
                <LogOut className="h-4 w-4" />
              </Button>
              <ChangePasswordModal open={pwOpen} onOpenChange={setPwOpen} />
            </>
          ) : (
            <Button
              data-testid="header-login-btn"
              variant="ghost"
              onClick={() => navigate("/login")}
              className="rounded-full border border-white/10 text-zinc-200 hover:text-white hover:bg-white/5"
            >
              Login
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
